<template>
  <WidgetLayout :background-color="backgroundColor" class="info-card-grid" :class-name="cardColor">
    <div class="flex gap-0 flex-wrap justify-center">
      <div v-for="(card, index) in infoCards" :key="index" class="flex p-1 lg:p-4 basis-full md:basis-1/2 lg:basis-1/3">
        <InfoCard v-bind="card" />
      </div>
    </div>
  </WidgetLayout>
</template>

<script lang="ts" setup>
import type { InfoCardStyleOptions, TranslatableString } from '~/types/widgets/widgetTypes'
import WidgetLayout from '~/components/Widgets/WidgetLayout.vue'
import InfoCard from '~/components/Widgets/InfoCard/InfoCard.vue'

type InfoCardType = {
  title: TranslatableString
  description: TranslatableString
  slug?: string
  image?: TranslatableString
  icon?: TranslatableString
  noPadding: boolean
}[]

const { infoCards, backgroundColor, cardsStyle } = defineProps<{
  infoCards: InfoCardType
  backgroundColor?: string
  cardsStyle?: InfoCardStyleOptions[] | InfoCardStyleOptions | string
}>()

const cardColor = computed<string>(() => {
  const style = Array.isArray(cardsStyle) ? cardsStyle[0] : cardsStyle

  return `card-${String(style).toLowerCase()}`
})
</script>

<style lang="postcss" scoped>
.info-card-grid {
  :deep(.card-white) {
    .info-card {
      .info-card-inner {
        background-color: theme('colors.white');
        border-color: transparent;

        .card-icon,
        .card-image {
          background-color: theme('colors.white');
        }
      }
    }
  }

  :deep(.card-gray) {
    .info-card {
      .info-card-inner {
        @apply bg-gray1 dark:bg-dmGray1;

        .card-icon,
        .card-image {
          @apply bg-gray1 dark:bg-dmGray1;
        }
      }
    }
  }
}

.dark {
  .info-card-grid {
    @apply bg-transparent !important;
  }
}
</style>
